<template>
	<div>
		<b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="spoolModal" id="spoolModal" :title="title" size="lg" @ok="ok" @hidden="hidden" @cancel="cancel" @shown="shown" :ok-disabled="$store.state.ajax_in_progress || (model.id != null && !$store.getters.hasPermission(['project_spool_management'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.spool_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" required class="form-control" v-model="model.spool_no">
                        </div>
                    </div>

                    <div class="row mb-3" style="z-index: 0;">
                        <div class="col-lg-4">
                            <label>{{ $t('table.progress_status') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0;">
                            <input disabled type="text" class="form-control" v-model="model.work_history_progress_status">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.line">
                        <div class="col-lg-4">
                            <label>{{ $t('table.line_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" disabled class="form-control" v-model="model.line.line_number">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.iso_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" disabled class="form-control" v-model="model.iso_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.team_picked_up') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedTeamPickedUp"
                                :options="currentTeamPickedUp"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isTeamPickedUpLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onTeamPickedUpSearch"
                                @input="updateTeamPickedUp"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedTeamPickedUp != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedTeamPickedUp"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.team_pickup_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.user_picked_up') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedUserPickup"
                                :options="currentUserPickup"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isUserPickupLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onUserPickupSearch"
                                @input="updateUserPickupUp"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedUserPickup != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedUserPickup"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.team_stored') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedTeamStored"
                                :options="currentTeamStore"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isTeamStoreLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onTeamStoreSearch"
                                @input="updateTeamStore"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedTeamStored != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedTeamStore"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.team_store_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.user_stored') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedUserStore"
                                :options="currentUserStore"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isUserStoreLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onUserStoreSearch"
                                @input="updateUserStore"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedUserStore != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedUserStore"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ndt_test') }}</label>
                        </div>
                        <div class="col-lg-8 mt-1" style="z-index: 0">
                            <toggle-button v-model="model.ndt_test" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.heat_treatment') }}</label>
                        </div>
                        <div class="col-lg-8 mt-1" style="z-index: 0">
                            <toggle-button v-model="model.heat_treatment" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.storage') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedStorage"
                                :options="currentStorage"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isStorageLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onStorageSearch"
                                @input="updateStorage"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedStorage != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedStorage"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.x_axis') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.x_axis">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.y_axis') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.y_axis">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.storage_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.storage_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pick_up_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.picked_up_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.delayed') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0;">
                            <toggle-button v-model="model.delayed" :sync="true" :value="false" :color="{checked: '#ff471a'}" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remark_1') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.remark1"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remark_2') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.remark2"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remark_3') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.remark3"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.material_picked_up') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.material_picked_up" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting_done') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.painting_done" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.prefab_started') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.prefab_started" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.prefab_finished') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.prefab_finished" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.prefab_visual_test') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.prefab_visual_test" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.prefab_checked') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.prefab_checked" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.prefab_ndt_finished') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.prefab_ndt_finished" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.prefab_pwht_finished') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.prefab_pwht_finished" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ready_erection') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.ready_erection" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.spool_picked_up') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.spool_picked_up" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.erection_started') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.erection_started" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.welding_finished') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.welding_finished" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.supports_installed') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.supports_installed" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.erection_visual_test') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.erection_visual_test" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.erection_checked') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.erection_checked" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.erection_ndt_finished') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.erection_ndt_finished" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.erection_pwht_finished') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.erection_pwht_finished" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ready_pressure_test') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.ready_pressure_test" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.partial_pressure_test') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.partial_pressure_test" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pressure_test_finished') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.pressure_test_finished" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.reinstallment_done') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.reinstallment_done" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting_finished') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.painting_finished" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_finished') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.insulation_finished" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>
                </div>
            </div>
		</b-modal>
	</div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';

export default {
	name: 'SpoolModal',
    components: {
		flatPickr,
		notificationIcons,
		Multiselect,
	},
	props: {
		item: {
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		table: {
			type: String,
            default: ''
		},
		model: {
			type: Object,
			default: () => ({
				id: null,
				drawing_id: null,
				line: { 'line_number': ''},
                line_id: null,
				iso_no: null,
				user_store_id: null,
                user_pickup_id: null,
                team_pickup_id: null,
                team_store_id: null,
                ndt_test: null,
                heat_treatment: null,
                picked_up_date: null,
                storage_date: null,
                spool_no: null,
                remark1: null,
                remark2: null,
                remark3: null,
                storage_id: null,
                x_axis: null,
                y_axis: null,
                reinstallment_done: null,
                selectedTeamPickedUp: null,
                selectedUserPickup: null,
                selectedTeamStored: null,
                selectedUserStore: null,
                selectedStorage: null,
                work_history_progress_status: null,

                material_picked_up: null,
                painting_done: null,
                prefab_started: null,
                prefab_finished: null,
                prefab_visual_test: null,
                prefab_checked: null,
                prefab_ndt_finished: null,
                prefab_pwht_finished: null,
                ready_erection: null,
                spool_picked_up: null,
                erection_started: null,
                supports_installed: null,
                welding_finished: null,
                erection_visual_test: null,
                erection_checked: null,
                erection_ndt_finished: null,
                erection_pwht_finished: null,
                ready_pressure_test: null,
                partial_pressure_test: null,
                pressure_test_finished: null,
                painting_finished: null,
                insulation_finished: null,
                delayed: null,
			})
		}
	},
    mounted() {
	},
	data() {
		return {
            isTeamPickedUpLoading: false,
            currentTeamPickedUp: [],

            isUserPickupLoading: false,
            currentUserPickup: [],

			isTeamStoreLoading: false,
            currentTeamStore: [],

			isUserStoreLoading: false,
            currentUserStore: [],

			isStorageLoading: false,
            currentStorage: [],
		}
	},
	computed: {
        statuses: {
            get: function () {
                let statuses = this.$store.getters.getSpoolStatus;
                return statuses;
            }
        }
    },
    watch: {
        statuses: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
	methods: {
		hidden(e) {
			this.$emit('hidden', e);
		},
		ok (e) {
            e.preventDefault();
            
            let put_data = {
                line_id:        this.model.line_id,
                drawing_id:     this.model.drawing_id,
                storage_id:     this.model.storage_id,
                team_pickup_id: this.model.team_pickup_id,
                user_pickup_id: this.model.user_pickup_id,
                team_store_id:  this.model.team_store_id,
                user_store_id:  this.model.user_store_id,
                ndt_test:       this.model.ndt_test,
                heat_treatment: this.model.heat_treatment,
                spool_no:       this.model.spool_no,
                x_axis:         this.model.x_axis,
                y_axis:         this.model.y_axis,
                storage_date:   this.model.storage_date,
                picked_up_date: this.model.picked_up_date,
                remark1:        this.model.remark1,
                remark2:        this.model.remark2,
                remark3:        this.model.remark3,
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.model.id != null) {
                http.route('spool/' + this.model.id).patch(put_data, true).then(response => {
                    if(response.isError == false) {
                        this.$emit('onLoadTable');
                        this.$emit('onLoadTableMain');
                        this.successMsg(Vue.i18n.translate('messages.spool_updated'));
                        this.$refs.spoolModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                http.route('spool').post(put_data, true).then(response => {
                    if(response.isError == false) {
                        this.$emit('onLoadTable');
                        this.$emit('onLoadTableMain');
                        this.successMsg(Vue.i18n.translate('messages.spool_created'));
                        this.$refs.spoolModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
		successMsg(msg) {
			miniToastr.success(msg, Vue.i18n.translate('messages.success'));
		},
		errorMsg(msg) {
			miniToastr.error(msg, Vue.i18n.translate('messages.error'));
		},
		cancel(e) {
			this.$emit('cancel', e);
		},
		shown(e) {
			this.$emit('shown', e);
		},
		show() {
			this.$refs.spoolModal.show();
		},
		clear() {
            this.model.id = null;
			this.model.work_history_progress_status = null;
			this.model.user_store_id = null;
            this.model.user_pickup_id = null;
            this.model.team_pickup_id = null;
            this.model.team_store_id = null;
            this.model.ndt_test = null;
            this.model.heat_treatment = null;
            this.model.picked_up_date = null;
            this.model.storage_date = null;
            this.model.spool_no = null;
            this.model.prefab_visual_test = null;
            this.model.prefab_checked = null;
            this.model.prefab_ndt_finished = null;
            this.model.prefab_pwht_finished = null;
            this.model.ready_erection = null;
            this.model.erection_visual_test = null;
            this.model.erection_checked = null;
            this.model.erection_ndt_finished = null;
            this.model.erection_pwht_finished = null;
            this.model.ready_pressure_test = null;
            this.model.partial_pressure_test = null;
            this.model.painting_finished = null;
            this.model.insulation_finished = null;
            this.model.remark1 = null;
            this.model.remark2 = null;
            this.model.remark3 = null;
            this.model.storage_id = null;
            this.model.x_axis = null;
            this.model.y_axis = null;
            this.model.material_picked_up = null;
            this.model.painting_done = null;
            this.model.prefab_started = null;
            this.model.prefab_finished = null;
            this.model.spool_picked_up = null;
            this.model.erection_started = null;
            this.model.welding_finished = null;
            this.model.supports_installed = null;
            this.model.pressure_test_finished = null;
            this.model.reinstallment_done = null;
            this.model.delayed = null;

            this.currentTeamPickedUp = [];
            this.currentUserPickup   = [];
            this.currentTeamStore    = [];
            this.currentUserStore    = [];
            this.currentStorage      = [];

            this.model.selectedTeamPickedUp = null;
            this.model.selectedUserPickup   = null;
            this.model.selectedTeamStored    = null;
            this.model.selectedUserStore    = null;
            this.model.selectedStorage      = null;
		},
        onTeamPickedUpSearch(search) {
            if (search == '') {
                this.currentTeamPickedUp = [];

                return false;
            }

            this.isTeamPickedUpLoading = true;
            this.searchTeamPickedUp(search, this);
        },
        searchTeamPickedUp: _.debounce((search, vm) => {
            let data = http.route('team?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentTeamPickedUp = response.data;
                }
                vm.isTeamPickedUpLoading = false;
            });
        }, 500),
		updateTeamPickedUp(team_pickup) {
            this.currentUserPickup = [];
            this.clearSelectedUserPickup();

            if (team_pickup == null) {
                this.model.team_pickup_id = null;
                this.currentUserPickup = [];
            } else {
                this.model.team_pickup_id = team_pickup.id;

                http.route('team/' + team_pickup.id +'/members?project_id='+this.$route.params.id).get().then(response => {
                    this.currentUserPickup = response.data;
                });
            }
        },
        clearSelectedTeamPickedUp () {
            this.model.selectedTeamPickedUp = null;
            this.model.team_pickup_id       = null;
            this.clearSelectedUserPickup();
        },
        onUserPickupSearch(search) {
            if (search == '') {
                this.currentUserPickup = [];
                
                return false;
            }

            this.isUserPickupLoading = true;
            this.searchUserPickupSearch(search, this);
        },
        searchUserPickupSearch: _.debounce((search, vm) => {
            var id = vm.model.team_pickup_id;
            if (id != null) {
                let data = http.route('team/' + id +'/members?project_id='+vm.$route.params.id+'&get_all=1&search_select' + search).get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentUserPickup = response.data;
                    }
                    vm.isUserPickupLoading = false;
                });
            }
        }, 500),
		updateUserPickupUp(user_pickup) {
            this.model.user_pickup_id = (user_pickup != null) ? user_pickup.user_id : null;
        },
        clearSelectedUserPickup () {
            this.model.selectedUserPickup = null;
            this.model.user_pickup_id     = null;
        },
        onTeamStoreSearch(search) {
            if (search == '') {
                this.currentTeamStore = [];

                return false;
            }

            this.isTeamStoreLoading = true;
            this.searchTeamStore(search, this);
        },
        searchTeamStore: _.debounce((search, vm) => {
            let data = http.route('team?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentTeamStore = response.data;
                }
                vm.isTeamStoreLoading = false;
            });
        }, 500),
		updateTeamStore(team_store) {
            this.currentUserStore = [];
            this.clearSelectedUserStore();

            if (team_store == null) {
                this.model.team_store_id = null;
                this.currentUserStore = [];
            } else {
                this.model.team_store_id = team_store.id;

                http.route('team/' + team_store.id +'/members?project_id='+this.$route.params.id).get().then(response => {
                    this.currentUserStore = response.data;
                    this.currentUserStoreNoSelect = true;
                });
            }
        },
        clearSelectedTeamStore () {
            this.model.selectedTeamStored = null;
            this.model.team_store_id      = null;
            this.clearSelectedUserStore();
        },
        onUserStoreSearch(search) {
            if (search == '') {
                this.currentUserPickup = [];

                return false;
            }

            this.isUserStoreLoading = true;
            this.searchUserStoreSearch(search, this);
        },
        searchUserStoreSearch: _.debounce((search, vm) => {
            var id = vm.model.team_store_id;
            if (id != null) {
                let data = http.route('team/' + id +'/members?project_id='+vm.$route.params.id+'&get_all=1&search_select' + search).get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentUserStore = response.data;
                    }
                    vm.isUserStoreLoading = false;
                });
            }
        }, 500),
        updateUserStore(user_store) {
            this.model.user_store_id = (user_store != null) ? user_store.user_id : null;
        },
        clearSelectedUserStore () {
            this.model.selectedUserStore = null;
            this.model.user_store_id     = null;
        },
        onStorageSearch(search) {
            if (search == '') {
                this.currentStorage = [];

                return false;
            }

            this.isStorageLoading = true;
            this.searchStorageSearch(search, this);
        },
        searchStorageSearch: _.debounce((search, vm) => {
            let data = http.route('storage?project_id='+vm.$route.params.id+'&get_all=1&search_select' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentStorage = response.data;
                }
                vm.isStorageLoading = false;
            });
        }, 500),
		updateStorage(storage) {
            this.model.storage_id = (storage != null) ? storage.id : null;
        },
        clearSelectedStorage () {
            this.model.selectedStorage = null;
            this.model.storage_id      = null;
        },
	}
}
</script>

<style scoped>
    select {
        -webkit-appearance:menulist-button;
        -moz-appearance:menulist-button;
    }
</style>


// WEBPACK FOOTER //
// src/components/global/modals/SpoolModal.vue